<!-- 推荐求购信息 -->
<template>
<div class="info-block">
  <router-link :to="'/sggq/qgDetail/2/'+info.id" class="info-block-a"  target="_blank">
    <div class="div-1">
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table">
          <tr>
            <td class="td-title">计划采购</td>
            <td class="td-title">截止时间</td>
          </tr>
          <tr>
            <td class="td-value">{{info.supply_amount}}{{info.unit}}</td>
            <td class="td-value">{{info.expiry_date}}</td>
          </tr>
        </table>
      </div>
    </div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'SgqgtjInfo',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:120px;
  padding:0px;
  margin:0px 0px 10px 0px;
  background-color: #eee;
  border:1px solid #F6F8F9;
  background-size: 220px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.info-block .info-block-a:hover .div-1-1{
  color:var(--color6);
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 10px 0px 10px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:50px;
  //background:red;
  font-size:14px;
  font-weight:500;
  text-align:left;
  color:#000;
  padding:10px 10px 10px 0px;
}

.div-1-4{
  position:relative;
  height:70px;
  //background:green;
  text-align:left;
  color:#bbb;
  padding:10px 0px 10px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:100px;
  color:#888;
  padding-left:0px;
}

.div-1-4-table .td-value{
  text-align:left;
  font-size:12px;
  font-weight:600;
  line-height:30px;
  color:var(--color7);
}

.div-1-4-table .td-value span{
  text-align:left;
  background:var(--color6);
  margin-left:5px;
  font-size:10px;
  font-weight:100;
  color:#fff;
}




.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/SgqgtjInfo.vue